module.exports = __webpack_public_path__ + "img/_DSC6802.0c9044f2.jpg";